<template>
  <div>
    <!-- 缩略图容器 -->
    <div class="image-viewer">
      <img :src="imageUrl" :alt="alt" />
      <label for="fullscreen-toggle" class="overlay">
        <div class="zoom-icon" @click="toggleFullscreen"></div>
      </label>
    </div>

    <input type="checkbox" id="fullscreen-toggle" />
    <div class="fullscreen-view" ref="overlayImg">
      <img :src="imageUrl" :alt="alt" />
      <label for="fullscreen-toggle" class="close-btn" @click="toggleFullscreen">&times;</label>
    </div>
  </div>
</template>

<script >
import { ref } from '@nuxtjs/composition-api';
export default {
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      default: 'Image'
    }
  },
  setup(porps, context) {
    const show = ref(false);
    const overlayImg = ref(null);
    const toggleFullscreen = (event) => {
      // 防连点
      if (event) {
        event.stopPropagation();
      }
      show.value = !show.value;
      if (show.value) {
        overlayImg.value.style.display = 'block';
      } else {
        overlayImg.value.style.display = 'none';
      }
    };
    return {
      show,
      toggleFullscreen,
      overlayImg
    };
  }
};
</script>

<style lang="scss" scoped>
.image-viewer {
  position: relative;
  // width: 300px;
  height: 100%;
  overflow: hidden;
  cursor: pointer;
}

.image-viewer img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.zoom-icon {
  width: 40px;
  height: 40px;
  // background-color: #ffffff;
  border-radius: 50%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.zoom-icon::before {
  content: '';
  width: 18px;
  height: 18px;
  border: 2px solid white;
  border-radius: 50%;
  position: absolute;
  top: 8px;
  left: 8px;
}

.zoom-icon::after {
  content: '';
  width: 2px;
  height: 10px;
  background-color: white;
  position: absolute;
  bottom: 8px;
  right: 10px;
  transform: rotate(-45deg);
}

.image-viewer:hover .overlay {
  opacity: 1;
}

.fullscreen-view {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  z-index: 1000;
  overflow: auto;
}

.fullscreen-view img {
  display: block;
  max-width: 90%;
  max-height: 90%;
  margin: 5% auto;
  object-fit: contain;
}

.close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  color: white;
  font-size: 30px;
  cursor: pointer;
}

#fullscreen-toggle {
  display: none;
}

// #fullscreen-toggle:checked + .fullscreen-view {
//   display: block;
// }
</style>
